import React from 'react';
import ReactSwitch from 'react-switch';

type Props = {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<{}>, checked: boolean) => void;
};

function Switch(props: Props) {
  return (
    // @ts-ignore
    <ReactSwitch
      id="icon-switch"
      height={22}
      width={40}
      uncheckedIcon={false}
      checkedIcon={false}
      onColor="#29CF6A"
      {...props}
    />
  );
}

Switch.defaultProps = {
  checked: false,
  disabled: false,
  onChange: () => {},
};

export { Switch };
